let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("kNFvF"), load("fliVL"), load("76n7a"), load("l253H"), load("ffQaD"), load("kvRbA"), load("2prKh")]).then(() => parcelRequire('fmton'));